import { uploadFile } from "@/utils/request";

export const uploadImage = file => new Promise((resolve) => uploadFile({
  file,
  path: 'upload',
  onSuccess: resolve,
  onFail: () => resolve()
}))